import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';

const Typical = dynamic(() => import('react-typical'), {
  ssr: false,
});
export default React.memo(function TypicalComponent(props) {
  const { trendingSearchData } = props;
  const [typicalData, setTypicalData] = useState([]);

  useEffect(() => {
    if (trendingSearchData?.length > 0) {
      let temp = [];
      for (let i = 0; i < 4; i++) {
        let searchData = trendingSearchData?.[i];
        let searchString = `Search for ${searchData}`;
        temp.push(searchString);
        temp.push(2000);
      }
      setTypicalData(temp);
    }
  }, []);
  return <Typical steps={typicalData} loop={100} />;
});
